import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

import { ThemeService } from '../../data/theme.service';

@Component({
  selector: 'offconon-shared-ui-theme-switch',
  imports: [MatIcon, TooltipModule, TranslateModule, CommonModule],
  template: ` <a
    tooltipPosition="bottom"
    class="flex p-3 lg:px-3 lg:py-2 items-center text-600 hover:bg-blue-500 hover:text-white font-bold p-button-rounded cursor-pointer transition-duration-150 transition-colors"
    [appendTo]="'body'"
    [pTooltip]="((darkModeSubscription | async) ? 'Dark mode off' : 'Dark mode on') | translate"
    (click)="toggleDarkMode()">
    <mat-icon
      class="text-base text-2xl"
      [fontIcon]="(darkModeSubscription | async) ? 'light_mode' : 'dark_mode'" />
  </a>`,
  styles: [],
})
export class SharedUiThemeSwitchComponent {
  private themeService = inject(ThemeService);
  darkModeSubscription = this.themeService.darkModeObservable;

  public toggleDarkMode(): void {
    this.themeService.toggleDarkMode();
  }
}
